module.exports = __webpack_public_path__ + "32b6b45aff124efb1c76b38738baf2dc.svg";